export const base_path ='/'
export const img_path =''
export const CLIENT_BASE_PATH ='https://alharamaincab.com'
export const API_BASE_URL = 'https://api.alharamaincab.com';
export const GOOGLE_CLIENT_ID = '125648722161-lscj7e81cn9ujsb785mg4het8qqn4f07.apps.googleusercontent.com';
export const FACEBOOK_APP_ID = '447741002724646';
